<template>
  <div>
    <v-text-field v-model="thisTitle" placeholder="请输入标题" hide-details style="font-size:20px;">
      <template v-slot:append>
        <p :style="{'color':thisTitle.length > 20 ? '#ff5252' : '#a6a6a6'}">{{thisTitle.length}}/20</p>
      </template>
    </v-text-field>

  </div>


</template>

<script>
export default {
  name: "Title",
  props:["title"],
  data(){
    return{
      thisTitle:"",
    }
  },
  watch:{
    title(){
      this.thisTitle = this.title;
    },
    thisTitle(){
      this.$emit("changeTitle",this.thisTitle)
    }
  },
  mounted(){
    this.thisTitle = this.title;
  }

}
</script>

<style scoped>


</style>
